import { createApi, BaseQueryFn } from '@reduxjs/toolkit/query/react';
import axios, { AxiosRequestConfig, AxiosError } from 'axios';
import keys from '../../config';

const axiosInstance = axios.create({
    baseURL: (keys.API_BASE as string) + '/api',
    headers: {
        Accept: 'application/json, text/plain, */*',
    },
});

const axiosBaseQuery =
    (): BaseQueryFn<
        {
            url: string;
            method: AxiosRequestConfig['method'];
            data?: AxiosRequestConfig['data'];
            params?: AxiosRequestConfig['params'];
            headers?: AxiosRequestConfig['headers'];
            responseType?: AxiosRequestConfig['responseType'];
        },
        unknown,
        unknown
    > =>
    async ({ url, method, data, params, headers, responseType }) => {
        try {
            const result = await axiosInstance({
                withCredentials: true,
                url,
                method,
                data,
                params,
                headers,
                responseType,
            });

            return { data: result.data };
        } catch (axiosError) {
            const err = axiosError as AxiosError;
            return {
                error: {
                    status: err.response?.status,
                    data: err.response?.data || err.message,
                },
            };
        }
    };

export const cdmApi = createApi({
    baseQuery: axiosBaseQuery(),
    tagTypes: [
        'Product',
        'Aliases',
        'Users',
        'CompanyGroup',
        'Lists',
        'List',
        'Pictures',
        'ProductKeywords',
        'KeywordCategories',
        'Secto',
        'Facs',
        'Colors',
        'InternationalCompanyGroup',
        'SalesData',
        'InternationalUsers',
    ],
    endpoints: () => ({}),
});
